import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/?search=${encodeURIComponent(searchQuery)}`);
      setSearchQuery("");
    }
  };

  const scrollToSection = (selector, offset = -90) => {
    const section =
      document.querySelector(selector) || document.getElementById(selector);
    if (section) {
      const y =
        section.getBoundingClientRect().top + window.pageYOffset + offset;
      window.scrollTo({ top: y, behavior: "smooth" });
    } else {
      navigate(`/#${selector.replace(".", "")}`);
    }
  };

  return (
    <nav className="navbar sticky top-0 z-50 backdrop-blur-md">
      <div className="content-wrapper">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link
            to="/"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex items-center"
          >
            <h1 className="text-2xl font-bold gradient-text">Effendialogue</h1>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="text-gray-300 hover:text-yellow-400 transition-colors"
            >
              Home
            </Link>

            <Link
              to="/articles"
              className="text-gray-300 hover:text-yellow-400 transition-colors"
            >
              Articles
            </Link>

            <button
              onClick={() => scrollToSection("author-section", -90)}
              className="text-gray-300 hover:text-yellow-400 transition-colors"
            >
              Author
            </button>
          </div>

          {/* Newsletter Button */}
          <div className="hidden md:flex items-center">
            <Button
              onClick={() => scrollToSection(".newsletter-section", -100)}
              className="bg-yellow-500 hover:bg-yellow-600 text-black px-6 py-2 font-semibold"
            >
              Newsletter
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <Button
            data-testid="mobile-menu-button"
            variant="ghost"
            size="sm"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-gray-300"
          >
            {isMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </Button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-700">
            <div className="flex flex-col space-y-4">
              <Link
                to="/"
                className="text-gray-300 hover:text-yellow-400 transition-colors px-2 py-1"
                onClick={() => {
                  setIsMenuOpen(false);
                  setTimeout(
                    () => window.scrollTo({ top: 0, behavior: "smooth" }),
                    100
                  );
                }}
              >
                Home
              </Link>

              <Link
                to="/articles"
                className="text-gray-300 hover:text-yellow-400 transition-colors px-2 py-1"
                onClick={() => setIsMenuOpen(false)}
              >
                Articles
              </Link>

              <button
                onClick={() => {
                  setIsMenuOpen(false);
                  setTimeout(() => scrollToSection("author-section", -90), 100);
                }}
                className="text-gray-300 hover:text-yellow-400 transition-colors px-2 py-1 text-left"
              >
                Author
              </button>

              {/* Mobile Newsletter Button */}
              <Button
                onClick={() => {
                  setIsMenuOpen(false);
                  setTimeout(() => scrollToSection(".newsletter-section", -100), 100);
                }}
                className="bg-yellow-500 hover:bg-yellow-600 text-black mx-2 mt-2"
              >
                Newsletter
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
